import { useTranslation } from "react-i18next";
import bouncieApiLogo from "~/assets/logos/integration-bouncie-api.svg";
import zapierLogo from "~/assets/logos/integration-zapier.svg";
import fleetioLogo from "~/assets/logos/integration-fleetio.svg";
import fleetyrLogo from "~/assets/logos/integration-fleetyr.svg";
import { Link } from "~/components/ui/link";
import { DEVELOPER_DOCS_URL } from "~/lib/external-links";
import { cn } from "~/lib/utils";

const ZAPIER_URL = "https://zapier.com/apps/bouncie/integrations";

// Each slot is the logo's Figma box height; the SVGs' own padding may overflow it by a pixel.
const slotClassName = "flex items-center justify-center lg:h-[41px]";

// Partner logos on a Bg-Secondary card. Must render inside the .fleet token scope.
export function FleetIntegrations() {
  const { t } = useTranslation("fleet");

  return (
    <section aria-labelledby="fleet-integrations-title" className="pt-10 pb-[60px]">
      <div className="wrap">
        <div className="bg-bg-alt flex flex-col items-center gap-12 rounded-2xl px-6 py-10 text-center lg:px-[60px] lg:py-14">
          <div className="flex flex-col items-center gap-4">
            <h2
              id="fleet-integrations-title"
              className="font-display text-text-heading text-xl leading-7 font-extrabold lg:text-4xl lg:leading-[1.1]"
            >
              {t("integrations.title")}
            </h2>
            <p className="text-text-body-secondary lg:text-md max-w-[748px] text-sm leading-5 lg:leading-[1.5]">
              {t("integrations.body")}
            </p>
          </div>

          <ul className="flex flex-col items-center gap-8 lg:flex-row lg:flex-wrap lg:justify-center lg:gap-x-10 lg:gap-y-8 xl:gap-x-24">
            <li className={cn(slotClassName, "h-[23px]")}>
              <a
                data-sid="fleet-integrations-bouncie-api"
                href={DEVELOPER_DOCS_URL}
                target="_blank"
                className="block"
                rel="noopener noreferrer"
                aria-label={t("integrations.bouncie_api")}
              >
                <img src={bouncieApiLogo} alt="" width={273} height={45} className="block h-auto w-[150px] lg:w-[229px]" />
              </a>
            </li>
            <li className={cn(slotClassName, "h-[41px]")}>
              <a
                data-sid="fleet-integrations-zapier"
                href={ZAPIER_URL}
                target="_blank"
                className="block"
                rel="noopener noreferrer"
                aria-label={t("integrations.zapier")}
              >
                <img src={zapierLogo} alt="" width={182} height={50} className="block h-auto w-[150px] lg:w-[152px]" />
              </a>
            </li>
            <li className={cn(slotClassName, "h-9")}>
              <Link
                data-sid="fleet-integrations-fleetio"
                to="/integration/fleetio"
                className="block"
                aria-label={t("integrations.fleetio")}
              >
                <img src={fleetioLogo} alt="" width={172} height={42} className="block h-auto w-[150px] lg:w-[172px]" />
              </Link>
            </li>
            <li className={cn(slotClassName, "h-10")}>
              <img src={fleetyrLogo} alt={t("integrations.fleetyr")} width={155} height={40} className="block h-auto w-[155px]" />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default FleetIntegrations;
